export default __webpack_public_path__ + "static/media/lock_icon.ff5a0ae3.svg";